import { render } from "./PageApplications.vue?vue&type=template&id=45257594"
import script from "./PageApplications.vue?vue&type=script&lang=js"
export * from "./PageApplications.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__